import React, { useEffect, useState } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import useHideBanners from "./useHideBanners.js";
import Icon from "../../Elements/Icon/Icon.tsx";

import "./Adsense.scss";

const Adsense = ({ bannerPosition, stylePorps = {}, size }) => {
  const { getBannerData } = useContent();
  const [collapsed, setCollapsed] = useState(false);

  const bannerData = getBannerData(bannerPosition);

  //here will add logic about if user have to see ads
  const userIsPro = useHideBanners();

  useEffect(() => {
    !userIsPro &&
      bannerData &&
      (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, [userIsPro]);

  //"download-page-top",
  //render
  return !userIsPro && bannerData ? (
    <div
      className={`${bannerPosition} ${collapsed ? "collapsed" : ""}`}
      style={stylePorps}
    >
      {bannerPosition === "download-bottom-sticky" ? (
        <div
          className="ad-toggle"
          onClick={() => setCollapsed((prev) => !prev)}
        >
          <Icon name="arrow-down-solid" />
        </div>
      ) : null}
      <ins
        className="adsbygoogle"
        style={{
          display:
            bannerData.BannerWidth > bannerData.BannerHeight
              ? "inline-block"
              : "block",
          width: bannerData.BannerWidth
            ? bannerData.BannerWidth + "px"
            : size?.width || "auto",
          height: bannerData.BannerHeight
            ? bannerData.BannerHeight + "px"
            : size?.height || "auto",
        }}
        data-full-width-responsive={bannerData.BannerResponsive ? true : false}
        data-ad-client={bannerData.BannerClient}
        data-ad-slot={bannerData.BannerSlot}
        data-ad-format={!bannerData.BannerHeight && !size ? "auto" : ""}
      ></ins>
    </div>
  ) : null;
};

export default Adsense;
